import {
  OnChangeFn,
  PaginationState,
  SortingState,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table"
import { useState } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { Table } from "~/components/table/Table"

import { useColumns } from "./columns"

type Props = {
  standardsList: AdminResponses.StandardsList[]
  certificateTypes: AdminResponses.CertificateType[]
  pageCount: number
  pagination: { pageIndex: number; pageSize: number }
  totalCertificateTypes: number
  setPagination: OnChangeFn<PaginationState>
}
export function CertificatesTable({
  standardsList,
  certificateTypes,
  totalCertificateTypes,
  pageCount,
  pagination,
  setPagination,
}: Props) {
  const [sorting, setSorting] = useState<SortingState>([
    { id: "name", desc: false },
  ])
  const columns = useColumns(standardsList)
  const table = useReactTable({
    data: certificateTypes,
    columns,
    state: {
      sorting,
      pagination,
      columnPinning: { left: ["name"] },
    },
    pageCount,
    manualPagination: true,
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })
  return (
    <Table
      table={table}
      pagination={true}
      manualPaginationCount={totalCertificateTypes || 0}
      pageIndex={pagination.pageIndex}
    />
  )
}
